// extracted by mini-css-extract-plugin
export default {"paymentInfo":"GygTourCheckout_paymentInfo__uQD1V"};